import { useMutation, useQueryClient } from '@tanstack/react-query';

import { updateViewerUser, type User } from '@/entities/viewer';
import { api } from '@/shared/api';

export interface ProfileValues {
  login: string;
  email: string;
  display_name: string;
  bio: string;
  locale: 'ru' | 'en';
  timezone: string;
  first_day_of_week: number;
}

export function useUpdateProfile() {
  const client = useQueryClient();
  return useMutation({
    mutationFn: (values: Partial<ProfileValues>) => api.patch<User>('/v1/account', values),
    onSuccess: (user) => {
      updateViewerUser(client, user);
    },
  });
}

export function useChangePassword() {
  return useMutation({
    mutationFn: (values: { current_password: string; new_password: string }) =>
      api.post('/v1/account/password', values),
  });
}
